import React from 'react';
import { usePerformanceAlerts } from '../hooks/usePerformanceAlerts';

const PerformanceAlerts: React.FC = () => {
  const { alerts, isMonitoring, dismissAlert, dismissAllAlerts, toggleMonitoring } = usePerformanceAlerts();

  if (!isMonitoring || alerts.length === 0) return null;

  const getSeverityColor = (severity: string) => {
    switch (severity) {
      case 'high': return 'bg-red-100 border-red-400 text-red-800';
      case 'medium': return 'bg-yellow-100 border-yellow-400 text-yellow-800';
      default: return 'bg-blue-100 border-blue-400 text-blue-800';
    }
  };

  const getSeverityIcon = (severity: string) => {
    switch (severity) {
      case 'high': return '🚨';
      case 'medium': return '⚠️';
      default: return 'ℹ️';
    }
  };

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2 max-w-sm">
      {alerts.map(alert => (
        <div
          key={alert.id}
          className={`border-l-4 p-3 rounded-r shadow-lg ${getSeverityColor(alert.severity)}`}
        >
          <div className="flex items-start justify-between">
            <div className="flex items-start gap-2">
              <span className="text-lg">{getSeverityIcon(alert.severity)}</span>
              <div>
                <div className="font-medium text-sm">{alert.message}</div>
                <div className="text-xs opacity-75 mt-1">
                  {new Date(alert.timestamp).toLocaleTimeString('tr-TR')}
                </div>
              </div>
            </div>
            <button
              onClick={() => dismissAlert(alert.id)}
              className="text-lg leading-none opacity-50 hover:opacity-100"
            >
              ×
            </button>
          </div>
        </div>
      ))}
      
      {alerts.length > 1 && (
        <div className="text-center">
          <button
            onClick={dismissAllAlerts}
            className="text-xs bg-gray-600 text-white px-3 py-1 rounded hover:bg-gray-700"
          >
            Tümünü Kapat ({alerts.length})
          </button>
        </div>
      )}
    </div>
  );
};

export default PerformanceAlerts;
